export default __webpack_public_path__ + "static/media/sand-blasting-icon.427771e9.svg";